import { render, staticRenderFns } from "./w-login-form.vue?vue&type=template&id=60e62a18"
import script from "./w-login-form.vue?vue&type=script&lang=js"
export * from "./w-login-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports